<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-sm btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Remark
    </button>
    <a-modal v-model="visible" title="Add a new remark">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Add Remark</a-button>
      </template>
      <a-form class="mb-4" :form="form" @submit="handleSubmit">
        <a-form-item label="Remark">
          <a-input
            placeholder="Remark"
            v-decorator="['exam_remark', {rules: [{ required: true, message: 'Please input a remark!' }]}]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AddExamRemark',
  props: ['enrollmentId', 'classSectionExamId'],
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
    }
  },
  computed: mapState(['user']),
  methods: {
    showModal() {
      this.visible = true
    },

    handleSubmit(e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to add a new remark!`,
            onOk: () => {
              this.$http
                .post('/api/studentexamremark', {
                  enrollment_id: this.enrollmentId,
                  class_section_exam_id: this.classSectionExamId,
                  exam_remark: values.exam_remark,
                  exam_remark_by: this.user.user.first_name + ' ' + this.user.user.last_name,
                  exam_remark_type: 'normal',
                })
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully added!',
                    description: `Remark has been added successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>
